/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { Flex, Image, Text } from '@chakra-ui/react';
import { gql, useLazyQuery } from '@apollo/client';
import useStore from '../store';
import c from '../constant';

const Q_DETAIL = gql`
	query get($id: String!) {
		getCompanyById(id: $id) {
			id
			name
			nameKhmer
			logo
			type
		}
	}
`;

function Company({ id = null, color = '#303030' }) {
	const { currentLang: lang } = useStore((state) => state.currentLang);
	const [fetchData, { data }] = useLazyQuery(Q_DETAIL);

	useEffect(() => fetchData({ variables: { id } }), [id]);

	return (
		<>
			{data?.getCompanyById && (
				<>
					<Flex justifyContent="left" alignItems="center">
						<Image src={c.baseFilePath + data?.getCompanyById?.logo} w="auto" minH="20px" h="20px" mr={2} />
						<Text color={color}>{lang === 'kh' ? data?.getCompanyById?.nameKhmer : data?.getCompanyById?.name}</Text>
					</Flex>
				</>
			)}
		</>
	);
}

export default Company;
